import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import {
  defaultLanguage,
  defaultLocale,
  CLIENT_TYPE,
  inApp,
  SOFI_TERMINAL_ID,
  MX_CITY_ID,
  SOFI_SDK_VERSION,
  SOFI_APP_VERSION,
} from "@/common/js/constant";
import { setHeader, setParam } from "./utils/requestCommon";
import "@/common/styles/reset.less";
import { useRouterReadyTime } from "./utils/routeObserver";
import { initializeSofipoToken } from "./utils/authToken";
// ========== 路由配置 =========== //
import routeConfig from "./routes";
import { withTokenReady } from "./routes/withTokenReady";

// ========== 主包 =========== //
import { trackEvent } from "./utils/omega";

// 设置cookie oid
import { setOidFromUrl } from "@/utils/utils";
setOidFromUrl();

const packageJson = require("../package.json");

import("@didi/elvish-lib-javascript")
  .then(({ init, setCity }) => {
    // 初始化elvish
    return init("es_MX")
      .then(() => setCity(MX_CITY_ID))
      .catch((e: unknown) => {
        // reset 墨西哥城市
        setCity(52151600);
        // 技术打点
        trackEvent("tech_sofi_catch_error", {
          source: "app.elvish.init",
          data: JSON.stringify(e),
        });
      });
  })
  .catch((e: unknown) => {
    // 技术打点
    trackEvent("tech_sofi_catch_error", {
      source: "app.elvish.init",
      data: JSON.stringify(e),
    });
  });

import("@didi/wsgsig")
  .then(({ initSign }) => {
    // 初始化签名
    initSign({
      env: "ame", // 非必填；ame：美东环境；默认不填，为国内环境；
      bizId: "8d5bfc00c5a5af5552bc7e595fc5dd70",
      appVer: packageJson.version, // 业务方自定义，方便问题排查时定位版本tag（此处应该是变化的，随业务版本更新进行变化，便于定位问题）
      os: "4", // 操作系统信息
    });
  })
  .catch((error: unknown) => {
    console.error("初始化签名失败:", error);
  });

// 设置客户端类型
setParam("fromType", CLIENT_TYPE);

// 增加通用header didi-header-hint-content
setHeader(
  "didi-header-hint-content",
  JSON.stringify({
    lang: defaultLanguage,
  }),
);

// 联调使用
// setParam(
//   "token",
//   "p8Zuc8r49_vYDmm4zfmWOrcwhLLlONBIst6cL2IMrrg0zDtqw1AQQNG9XNJlEPN5H2na9FlEEsXGxTPYuBLau5HB9YGzMZQkJp0UYRhpwnDSVbW5MAppfTGvc_fDKsnXN8IPaUWXEmFdI_qizTyEP7K1Lqzkxv36uP2u724X_o9ujjL7qzuRfNZDrUWv1eyjVnWEM4khXEjfnwEAAP__",
// );

// 设置tmxjs
// tmx设备指纹供应商0831试用期结束后处置：下线tmx设备指纹
// setParam("payrisk_info", JSON.stringify({ ln_session_id: "20230719" }));

// 设置wsgenv 改到拦截器里设置
// setParam("wsgenv", JSON.stringify({}));
// 设置locale
setParam("locale", defaultLocale.replace(/-/g, "_"));
// 设置terminal ID
setParam("terminal_id", SOFI_TERMINAL_ID);
// 设置默认语言
setParam("lang", defaultLanguage);
// 设置默认城市
setParam("cityId", MX_CITY_ID);
// 设置端版本号
setParam("sofipo_sdk_version", SOFI_SDK_VERSION);
// 设置端版本号
setParam("appversion", SOFI_APP_VERSION);



// URL 公参
if (window.location.search) {
  const params: URLSearchParams = new URLSearchParams(window.location.search);
  // 从URL参数中获取lat和lng
  setParam("lat", params.get("lat") || "");
  setParam("lng", params.get("lng") || "");

  // 如果存在idc标示，追加到所有请求上
  const idc: string | null = params.get("sofi_idc");
  if (idc) {
    setParam("sofi_idc", idc);
  }
}

// App 启动时只初始化一次 token，loader 会等待这个 Promise 完成。
if (inApp && window.Fusion) {
  void initializeSofipoToken();
}

// 公共路由path
const RouteBasename = process.env["BASE_PATH"] || "";

// AppContent 在路由上下文内部调用 useRouterReadyTime
function AppContent() {
  useRouterReadyTime();
  return <Outlet />;
}

// 使用 createBrowserRouter 创建路由实例，以 root RouteObject 包裹所有路由
const router = createBrowserRouter(
  [
    {
      element: <AppContent />,
      children: withTokenReady(routeConfig),
    },
  ],
  {
    basename: RouteBasename,
  },
);

export default function App() {
  return <RouterProvider router={router} />;
}
